import React, { useEffect, useState, useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import MonitoringHeaderTabs from 'flow/SiteMonitoring/components/Tabs'
import Button from 'components/Button'
import Modal from 'components/Modal'
import UserAddIcon from 'assets/icons/user-add'
import { SITE_STATUS_DRAFT_ID } from 'constants/siteStatuses'
import IconsRow from 'components/IconsRow'
import ManageMonitoringCoProposerModal from './components/ManageMonitoringCoProposerModal'
import { MonitoringContext } from 'providers/monitoring'
import DropdownIndicatorIconOpen from 'assets/icons/dropdown-indicator-opened24px'
import DropdownIndicatorIconClosed from 'assets/icons/dropdown-indicator-closed24px'
import ManageUserIcon from 'assets/icons/manage-users'
import {
  ButtonWrapper,
  NewSiteHeader,
  NewSiteHeaderDropdownIconWrapper,
  NewSiteHeaderDropdownMenu,
  NewSiteHeaderManageUserWrapper,
  NewSiteHeaderStatusIcon,
  NewSiteHeaderStatusWrapper,
  NewSiteHeaderTitle,
  NewSiteHeaderTitleWrapper,
  NewSiteHeaderUsersIcons,
  ProfileIconDiv
} from './style'
import ProfileIcon from 'components/ProfileIcon'
import { requestGetSiteCoProposers } from 'api/site'

const statusColor = {
  1: 'rgba(225, 25, 0, 1)',
  2: 'rgba(10, 161, 244, 1)',
  3: 'rgb(255, 153, 0)',
  4: 'rgba(146, 191, 0, 1)',
  5: 'rgba(5, 148, 79, 1)',
  6: 'rgb(239, 85, 137)',
  7: 'rgba(225, 25, 0, 1)',
  8: 'rgba(32, 32, 32, 1)',
  9: 'rgba(103, 58, 183, 1)',
  10: 'rgba(30, 144, 255, 0.6)'
}

const Header = () => {
  const routeParams = useParams()
  const { monitoring, mergedParams } = useContext(MonitoringContext)
  const params = mergedParams || routeParams
  const history = useNavigate()
  const location = useLocation()
  const pathnameSplit = location.pathname.split('/')
  const lastPieceOfPathname = pathnameSplit[pathnameSplit.length - 1]
  const [monitoringCoProposers, setMonitoringCoProposers] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [activeTab, setActiveTab] = useState(lastPieceOfPathname)
  const [isDropDownOpen, setIsDropDownOpen] = useState(false)

  async function getMonitoringCoProposers() {
    requestGetSiteCoProposers(params.id).then((data) => {
      const result = params.siteHistoryId ? data : data.siteCoProposers
      setMonitoringCoProposers(result)
    })
  }

  useEffect(() => {
    getMonitoringCoProposers()
  }, [monitoring?.monitoring_status])

  useEffect(() => {
    const pathnameSplit = location.pathname.split('/')
    const lastPieceOfPathname = pathnameSplit[pathnameSplit.length - 1]
    setActiveTab(lastPieceOfPathname)
  }, [location.pathname])

  function changeActiveTab(e) {
    const { id, monitoringId } = params
    const path = {
      about: () => history(`/site/${id}/monitoring/${monitoringId}/about`),
      pressure: () => history(`/site/${id}/monitoring/${monitoringId}/pressure`),
      response: () => history(`/site/${id}/monitoring/${monitoringId}/response`),
      state: () => history(`/site/${id}/monitoring/${monitoringId}/state`),
      guidanceandtools: () => history(`/site/${id}/monitoring/${monitoringId}/guidance-and-tools`),
      details: () => history(`/site/${id}/monitoring/${monitoringId}/details`),
      overview: () => history(`/site/${id}/monitoring/${monitoringId}/overview`)
    }
    setActiveTab(e.target.id)
    path[e.target.id]?.()
  }

  function toggleModal() {
    setIsModalOpen((s) => !s)
    getMonitoringCoProposers()
  }

  function openCoProposersDropdown() {
    if (monitoringCoProposers.length === 0) return
    setIsDropDownOpen((s) => !s)
  }

  const renderCoProposersList =
    monitoringCoProposers?.map((coProposer, i) => (
      <ProfileIconDiv key={i}>
        <ProfileIcon user={coProposer?.User} reviewer={true} />
      </ProfileIconDiv>
    )) || []
  const isDraft = monitoring?.monitoring_status === SITE_STATUS_DRAFT_ID
  return (
    <>
      <NewSiteHeader>
        <NewSiteHeaderTitleWrapper>
          <NewSiteHeaderTitle data-test="page-header">
            <FormattedMessage id="monitoringEvaluation" />
          </NewSiteHeaderTitle>
          <NewSiteHeaderStatusIcon
            data-testid="site-status"
            color={statusColor[monitoring?.monitoring_status] || 'gray'}
          />
          <NewSiteHeaderStatusWrapper>
            <FormattedMessage id={!isDraft ? 'confirmed' : 'draft'} />
          </NewSiteHeaderStatusWrapper>
        </NewSiteHeaderTitleWrapper>
        <MonitoringHeaderTabs changeTab={changeActiveTab} active={activeTab} />
        <NewSiteHeaderManageUserWrapper>
          <NewSiteHeaderUsersIcons width="172px" onClick={openCoProposersDropdown}>
            <IconsRow usersList={monitoringCoProposers} labelText="coProposers" />
          </NewSiteHeaderUsersIcons>
          <NewSiteHeaderDropdownIconWrapper isActive={isDropDownOpen}>
            <NewSiteHeaderManageUserWrapper onClick={openCoProposersDropdown}>
              {isDropDownOpen ? <DropdownIndicatorIconOpen /> : <DropdownIndicatorIconClosed />}
            </NewSiteHeaderManageUserWrapper>
            <NewSiteHeaderDropdownMenu isActive={isDropDownOpen && monitoringCoProposers.length > 0} className="scroll">
              {renderCoProposersList}
            </NewSiteHeaderDropdownMenu>
          </NewSiteHeaderDropdownIconWrapper>
          {isDraft && (
            <ButtonWrapper>
              <Button
                onClick={toggleModal}
                height="40px"
                withIcon={true}
                marginTop="0"
                dataTest="invite"
                type={'secondary'}
              >
                {monitoringCoProposers.length ? <ManageUserIcon /> : <UserAddIcon />}
                <FormattedMessage id={monitoringCoProposers.length ? 'manage' : 'invite'} />
              </Button>
            </ButtonWrapper>
          )}
        </NewSiteHeaderManageUserWrapper>
      </NewSiteHeader>
      <Modal
        width="640px"
        isOpen={isModalOpen && monitoring?.monitoring_status === SITE_STATUS_DRAFT_ID}
        toggleModal={toggleModal}
        modalTitleId="inviteCoProposers"
      >
        <ManageMonitoringCoProposerModal toggleModal={toggleModal} />
      </Modal>
    </>
  )
}
export default Header
